import React from "react";
import {
  ADMIN_ROLES,
  PERMISSIONS,
  hasPermission,
} from "../../../../constants/adminPermissions";
import { Check, X, Shield, Lock } from "lucide-react";

export default function RolesPermissionsPage() {
  const permissionCategories = [
    {
      category: "Tests Module",
      permissions: [
        { key: PERMISSIONS.TESTS_READ, label: "View Tests & Status (tests.read)" },
        { key: PERMISSIONS.TESTS_CREATE, label: "Create Tests (tests.create)" },
        { key: PERMISSIONS.TESTS_UPDATE, label: "Edit Tests & Sections (tests.update)" },
        { key: PERMISSIONS.TESTS_PUBLISH, label: "Publish / Unpublish Tests (tests.publish)" },
      ],
    },
    {
      category: "Questions Module",
      permissions: [
        { key: PERMISSIONS.QUESTIONS_READ, label: "View Question Bank (questions.read)" },
        { key: PERMISSIONS.QUESTIONS_CREATE, label: "Create / Bulk Upload Questions (questions.create)" },
        { key: PERMISSIONS.QUESTIONS_UPDATE, label: "Correct & Version Questions (questions.update)" },
        { key: PERMISSIONS.QUESTIONS_REVIEW, label: "Review Question Reports (questions.review)" },
      ],
    },
    {
      category: "Users Module",
      permissions: [
        { key: PERMISSIONS.USERS_READ, label: "View User Profiles (users.read)" },
        { key: PERMISSIONS.USERS_UPDATE, label: "Update User Status / Block (users.update)" },
        { key: PERMISSIONS.USERS_ACCESS_MANAGE, label: "Manage Plan & Entitlements (users.access.manage)" },
      ],
    },
    {
      category: "Mentors & Operations",
      permissions: [
        { key: PERMISSIONS.MENTORS_READ, label: "View Mentors & Reports (mentors.read)" },
        { key: PERMISSIONS.MENTORS_UPDATE, label: "Assign Students to Mentors (mentors.update)" },
        { key: PERMISSIONS.NOTIFICATIONS_CREATE, label: "Compose Notifications (notifications.create)" },
        { key: PERMISSIONS.NOTIFICATIONS_SEND, label: "Broadcast Notifications (notifications.send)" },
      ],
    },
    {
      category: "Analytics",
      permissions: [
        { key: PERMISSIONS.ANALYTICS_READ, label: "View User, Test & Payment Analytics (analytics.read)" },
      ],
    },
    {
      category: "System Administration",
      permissions: [
        { key: PERMISSIONS.ADMIN_MANAGE, label: "Manage Admin Users & Roles (admin.manage)" },
        { key: PERMISSIONS.AUDIT_READ, label: "View Full Audit Trail Logs (audit.read)" },
      ],
    },
  ];

  return (
    <div>
      <div
        className="admin-card"
        style={{ marginBottom: "20px", padding: "16px 20px" }}
      >
        <h3 style={{ fontSize: "16px", fontWeight: 700, margin: "0 0 6px 0", color: "#1e293b" }}>
          Centralized Role-Permission Matrix
        </h3>
        <p style={{ margin: 0, fontSize: "13px", color: "#64748b" }}>
          Permissions are centralized and checked dynamically across frontend navigation and backend authorization.
        </p>
      </div>

      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th style={{ width: "380px" }}>Permission Definition</th>
              {Object.values(ADMIN_ROLES).map((role) => (
                <th key={role} style={{ textAlign: "center" }}>
                  {role}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {permissionCategories.map((cat) => (
              <React.Fragment key={cat.category}>
                <tr style={{ background: "#f8fafc" }}>
                  <td
                    colSpan={5}
                    style={{
                      fontWeight: 700,
                      fontSize: "12px",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#475569",
                      padding: "8px 18px",
                    }}
                  >
                    {cat.category}
                  </td>
                </tr>

                {cat.permissions.map((perm) => (
                  <tr key={perm.key}>
                    <td style={{ fontSize: "13px", fontWeight: 500, color: "#1e293b" }}>
                      {perm.label}
                    </td>
                    {Object.values(ADMIN_ROLES).map((role) => {
                      const allowed = hasPermission(role, perm.key);
                      return (
                        <td key={role} style={{ textAlign: "center" }}>
                          {allowed ? (
                            <span
                              style={{
                                display: "inline-flex",
                                width: "24px",
                                height: "24px",
                                borderRadius: "50%",
                                background: "#dcfce7",
                                color: "#16a34a",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Check size={14} />
                            </span>
                          ) : (
                            <span
                              style={{
                                display: "inline-flex",
                                width: "24px",
                                height: "24px",
                                borderRadius: "50%",
                                background: "#f1f5f9",
                                color: "#cbd5e1",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <X size={14} />
                            </span>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
